<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import ArrowIcon from '@/components/shared/ArrowIcon.vue'

const { t } = useI18n()
</script>

<template>
  <section class="bg-white py-24">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="max-w-2xl">
        <p class="text-emerald-600 font-semibold text-sm uppercase tracking-widest">
          {{ t('home.organizers.section_label') }}
        </p>
        <h2 class="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
          {{ t('home.organizers.heading') }}
        </h2>
        <p class="text-slate-500 mt-4">
          {{ t('home.organizers.subtext') }}
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
        <div class="bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:border-emerald-200 hover:shadow-lg transition-all">
          <div class="w-10 h-10 text-emerald-500 mb-6">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <rect x="6" y="4" width="28" height="32" rx="3" stroke="currentColor" stroke-width="2.5" />
              <path d="M13 13h14M13 19h14M13 25h8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
              <rect x="22" y="22" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="2" fill="currentColor" fill-opacity="0.15" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900">{{ t('home.organizers.card_forms_title') }}</h3>
          <p class="text-slate-500 mt-3 leading-relaxed">{{ t('home.organizers.card_forms_body') }}</p>
        </div>

        <div class="bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:border-emerald-200 hover:shadow-lg transition-all">
          <div class="w-10 h-10 text-emerald-500 mb-6">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <circle cx="14" cy="14" r="5" stroke="currentColor" stroke-width="2.5" />
              <circle cx="26" cy="14" r="5" stroke="currentColor" stroke-width="2.5" />
              <path d="M6 34c0-5.523 3.582-10 8-10h12c4.418 0 8 4.477 8 10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
              <path d="M23 24l3 3 5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900">{{ t('home.organizers.card_mgmt_title') }}</h3>
          <p class="text-slate-500 mt-3 leading-relaxed">{{ t('home.organizers.card_mgmt_body') }}</p>
        </div>

        <div class="bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:border-emerald-200 hover:shadow-lg transition-all">
          <div class="w-10 h-10 text-emerald-500 mb-6">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <path d="M6 32V22M14 32V16M22 32V20M30 32V10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
              <path d="M6 18l8-6 8 4 8-8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              <circle cx="30" cy="8" r="2" fill="currentColor" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900">{{ t('home.organizers.card_sales_title') }}</h3>
          <p class="text-slate-500 mt-3 leading-relaxed">{{ t('home.organizers.card_sales_body') }}</p>
        </div>
      </div>

      <div class="mt-14 text-center">
        <RouterLink
          :to="{ name: 'public.for-organizers' }"
          class="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold rounded-lg px-6 py-3 transition-colors"
        >
          {{ t('home.organizers.cta') }}
          <ArrowIcon direction="right" class="w-4 h-4" />
        </RouterLink>
      </div>
    </div>
  </section>
</template>
